module.exports = __webpack_public_path__ + "img/TNP-Banner_links_unten_Startseite.3d06a742.png";